import React from 'react';
import PageContext, {IPageInfo} from 'helpers/context/Page/PageContext';

export default function usePageData(): IPageInfo {
    const pageInfo = React.useContext(PageContext);
    return pageInfo;
};


